import { call } from 'redux-saga/effects';
import { SERVER_IP, ud, jwt } from '../Server'
import Swal from 'sweetalert2'
import axios from 'axios';

function* deleteFAQ(action) {
    try {
        const { faq_id } = action
        yield call(
            async () => {
                var data = { faq_id }
                let headers = {
                    'user_id': (ud.id).toString(),
                    'session_id': (ud.session_id).toString(),
                    'user_type': (ud.usertype).toString(),
                    'main_id': (ud.main_id).toString(),
                    'jwt_token': (jwt),
                    'c_id': (ud.c_id).toString()
                }
                const result = await axios.post(`${SERVER_IP}/userfaq/delete`, data, { withCredentials: true, headers: headers })
                if (result.data.error === false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.msg,
                        icon: 'success',
                        confirmButtonText: 'Ok'
                    })
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: result.msg,
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }
            }
        );
    } catch (error) {
        console.log(error)
    }
}

export default deleteFAQ